import gql from 'graphql-tag';

export const getDeepLink = gql`
  query ($minisiteId: Int) {
    getDeepLink(minisiteId: $minisiteId) {
      minisiteId
      application {
        applicationId
      }
      title
      description
      cover {
        mediaId
        url
      }
      date
      bccList
      javascript
      notificationImage {
        mediaId
        url
      }
      deepLinkiOS
      deepLinkAndroid
    }
  }
`
